import _ from 'lodash';
import moment from 'moment'

export function isEmpty(val) {
	if (!val) {
		if (val !== 0 && val !== false) {
			return true
		}
	} else if (typeof val === "object") {
		if (Object.keys(val).length === 0) {
			return true
		}
	}
	return false
}

export function isUnique(data, row, key, subKey) {
	let returns;
	if (isEmpty(subKey)) {
		returns = data.find((dataRow) => {
			return _.isEqual(dataRow[key], row[key]);
		});
	} else {
		returns = data.find((dataRow) => {
			return _.isEqual(dataRow[key], row[key]) && _.isEqual(dataRow[subKey], row[subKey]);
		});
	}
	return isEmpty(returns)
}

export function isNum(val) {
	const reg = new RegExp(/^[0-9]*$/);
	return reg.test(val);
}

export function isNumLetter(val) {
	const reg = new RegExp(/^[a-zA-Z0-9]*$/);
	return reg.test(val);
}

export function isNumLetterSymbol(val) {
	const reg = new RegExp(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/);
	return reg.test(val);
}

export function isHankaku(val) {
	if (isEmpty(val)) return true;
	const reg = new RegExp(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/);
	return reg.test(val);
}

export function isPassword(val) {
	if (isEmpty(val)) return true;
	const reg = new RegExp(/^([a-zA-Z0-9!-/:-@¥[-`{-~]{4,})$/);
	return reg.test(val);
}

export function isDate(val) {
	if (isEmpty(val)) return true;
	const reg = new RegExp(/^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])$/);
	if (!(reg.test(val))) return false;

	return moment(val).isValid()

}

export function isMailAddress(val) {
	if (isEmpty(val)) return true;
	const reg = new RegExp(/^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/);
	return reg.test(val);
}


export function getMessage(code) {
	const msg = messages[code];
	if (!msg) return "入力エラー";
	return msg;
}


const messages = {
	"required": "必須入力",
	"numLetter": "半角英数字で入力",
	"numLetterSymbol": "半角英数字記号で入力",
	"password": "半角英数字記号4文字以上",
	"unique": "重複する値が存在します",
	"dateFormat": "日付が正しくありません",
	"mailAddress": "メールアドレスの形式が正しくありません",
	"nocode": "コードが存在しません"
};






// WEBPACK FOOTER //
// ./src/common/utils/validation.js